<script setup lang="ts">
/**
 * Renderer for the Race grid. This validates a few settings and show colored labels in the grid
 * for easy identification of what major functionality is in use. i.e. Relay, Cup, Tracking etc.
 *
 */
import { Race } from '@/objects/generated';

const props = defineProps<{
    value: any;

    /**
     * The row to render
     * TODO: This should be a reactive.
     */
    row: Race;
}>();
</script>

<template>
    <div class="d-flex flex-row flex-nowrap gap-2">
        <span
            class="badge bg-yellow-700 text-white bg-opacity-50"
            v-if="(row.RelayTeamMaxContestants ?? 0) > 0 || (row.RelayTeamMinContestants ?? 0) > 0"
            >{{ $tm('general.relay') }}</span
        >
        <span
            class="badge bg-blue-700 text-white bg-opacity-50"
            v-if="row.Pursuit"
            >{{ $tm('race.pursuit') }}</span
        >
    </div>
</template>
